import React from 'react';
import { Box, Radio, Stack, Typography } from '@mui/material';
import { useCurrentStateByControlUnitId } from '../../../redux/controlUnit/hooks/useCurrentStateByControlUnitId';
import { getPolyglot } from '../../../i18n';

interface StatusProps {
  value: boolean | undefined;
  icon: React.ReactElement;
  name?: string;
  deviceId: string;
  controlUnitId: string;
  actionId: string;
  CUTranslate: ReturnType<typeof useCurrentStateByControlUnitId>['CUTranslate'];
  switchColors?: {
    thumbColorOn?: string;
    thumbColorOff?: string;
    trackColorOn: string;
    trackColorOff?: string;
    iconColor?: string;
    buttonColor?: string;
  };
  isDeviceConnected?: boolean;
}
function ModeOven(props: StatusProps) {
  const polyglot = getPolyglot();
  const { value, name, icon, actionId, CUTranslate, isDeviceConnected } = props;

  const internalTranslation = polyglot.t(`device.actions.${actionId}`, {
    _: actionId,
  });
  const translation = (CUTranslate(actionId) as string) || internalTranslation;
  const actionName = name || translation;

  return (
    <Stack spacing={0.5} direction={'column'} alignItems={'center'}>
      <Box
        sx={{
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            fontSize: '1.5em',
            display: 'flex',
            color:
              value && isDeviceConnected
                ? (theme) => theme.palette.primary.main
                : (theme) => theme.palette.text.disabled,
            justifyContent: 'center',
            alignItems: 'center',
          }}
          padding={0.2}
        >
          {icon}
          <Typography fontSize={'0.6rem'} margin={'0.2rem'}>
            {actionName}
          </Typography>
          <Radio
            checked={value}
            disabled={!isDeviceConnected}
            sx={{ padding: '0.2rem 0' }}
          />
        </Box>
      </Box>
    </Stack>
  );
}

export default ModeOven;
